module.exports = __webpack_public_path__ + "static/media/globe.85962402.svg";